
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getSmsAccountBalanceList,
  editSmsSwitch
} from '@/api/product/smsManage'

@Component({
  name: 'balance',
  components: {}
})
export default class extends Vue {
  private queryForm: any = {
    merchant_no: ''
  }
  private total = 0
  private listLoading: boolean = false
  private balanceList: any = []
  private editInfo: any = {}

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.getBalanceList()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.getBalanceList()
  }

  // 商户余额列表
  private getBalanceList() {
    try {
      this.listLoading = true
      this.balanceList = []
      let data: any = {
        merchant_no: this.queryForm.merchant_no,
        page_size: this.pagesize,
        page: this.currentPage
      }
      getSmsAccountBalanceList(data).then((res: any) => {
        this.total = res.count
        this.balanceList = res.results
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private select() {
    this.getBalanceList()
  }

  private reset() {
    this.queryForm.merchant_no = ''
    this.getBalanceList()
  }

  // 商户余额操作
  private editBalanceVisible: boolean = false
  private editBalance(row: any) {
    this.editInfo = row
    this.editBalanceVisible = true
  }
  private closeEditBalance() {
    this.editBalanceVisible = false
    this.getBalanceList()
  }

  private async setStatus(row: any) {
    // 保存原来的状态
    const status = row.switch === '0' ? '1' : '0'
    let data: any = {
      merchant_no: row.merchant_no,
      switch: row.switch,
      id: row.id
    }
    try {
      await editSmsSwitch(data).then((res: any) => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
        this.getBalanceList()
      })
    } catch (e) {
      row.switch = status
    }
  }

  mounted() {
    this.getBalanceList()
  }
}
